export const MynaPortal = {
  MynaPortalLink: {
    Title: 'マイナポータル連携',
    MedicineListTitle: 'お薬手帳（マイナポータル）',
    InformationMessage:
      '　マイナポータルの情報を取得し、タヨリスで閲覧することができます。マイナポータルと連携する場合は「連携する」ボタンを押してください。' +
      '\n※タヨリス上で、本人確認できていることが条件となります。' +
      '\n※情報取得時に本人確認のためマイナポータルの認証サイトへ遷移します。マイナポータルをご利用頂くための動作環境については下記をご確認ください。' +
      '\n※マイナポータルの情報は最大100日分のデータが取得されます。',
    Environment: 'マイナポータルの動作環境はこちら',
    LinkDialogMessage:
      'マイナポータルからデータを取得します。宜しいでしょうか？' +
      '\n' +
      '\n※認証が必要な場合はマイナポータルの専用サイトへ遷移します。',
    ImportDialogMessage:
      'マイナポータルデータをインポートします。宜しいでしょうか？',
    LinkButton: '連携する',
    ImportButton: 'インポート',
    linkFailedMessage:
      'マイナポータル連携に失敗しました。しばらく時間をおいてからお試しください。\nステータスコード：',
    linkFailedSubText: '\n解決できない場合、お問い合わせください。',
    ImportFailedMessage:
      'データインポートに失敗しました。インポートするデータを確認してください。',
    SystemErrorMessage:
      'システムエラーが発生しました。サービスセンターにお問い合わせください。',
    ErrorButton: '確認',
    ExportDialogMessage:
      'マイナポータルから情報を取得しました。データを端末へ保存（エクスポート）しますか？',
    ExportButton: '端末へ保存',
    ExportCancelButton: '保存しない',
  },
};
